import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import './stylesheet.scss';
import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import FEATURE_FLAG_NAMES from 'platform/utilities/feature-toggles/featureFlagNames';
// eslint-disable-next-line @department-of-veterans-affairs/no-cross-app-imports
import { formUploadForms } from '../../../simple-forms/form-upload/config/formUploadForms';

export const App = ({ formNumber, hasOnlineTool }) => {
  const toggles = useSelector(toggleValues);
  const shouldShow = toggles[FEATURE_FLAG_NAMES.formUploadFlow];
  // QuickSubmit takes any form, so forms don't need registering with the
  // Form Upload app. It only exists where both My VA toggles are on.
  const useQuickSubmit =
    toggles[FEATURE_FLAG_NAMES.myVaBlueskyEnabled] &&
    toggles[FEATURE_FLAG_NAMES.myVaQuickSubmitUploadEnabled];
  // Until then, only forms the Form Upload app routes get a link; any other
  // form would land on a route that redirects to /forms.
  const inFormUpload = formUploadForms.some(
    id => id.toLowerCase() === formNumber?.toLowerCase(),
  );
  const href = useQuickSubmit
    ? '/my-va/forms/upload'
    : `/forms/upload/${formNumber?.toLowerCase()}`;

  if (shouldShow && hasOnlineTool === undefined) {
    return <va-loading-indicator message="Loading..." />;
  }

  if (shouldShow && !hasOnlineTool && (useQuickSubmit || inFormUpload)) {
    return (
      <>
        <h3>Submit completed form</h3>
        <p>After you complete the form, you can upload and submit it here.</p>
        <div className="action-bar-arrow">
          <div className="vads-u-background-color--primary vads-u-padding--1">
            <a className="vads-c-action-link--white" href={href}>
              Upload VA Form {formNumber}
            </a>
          </div>
        </div>
      </>
    );
  }

  return null;
};

App.propTypes = {
  hasOnlineTool: PropTypes.bool.isRequired,
  formNumber: PropTypes.string,
};

export default App;
